<template>
  <PageSidebar></PageSidebar>
  <div class="main">
    <PageHeader :title="pageTitle"></PageHeader>
<!--    <router-view></router-view>-->
    <router-view v-slot="{ Component,route }">
      <keep-alive>
        <component :is="Component" v-if="route.meta.keepAlive==true"  :key="route.path" />
      </keep-alive>
      <component :is="Component" v-if="route.meta.keepAlive==false"  :key="route.path" />
    </router-view>
  </div>
</template>

<script>
import PageHeader from "./components/PageHeader";
import PageSidebar from "./components/PageSidebar";

export default {
  name: "platform",
  components: {
    PageHeader,
    PageSidebar
  },
  data() {
    return {
      active: 0,
      pageTitle:"",
    };
  },
  watch: {
    // 监听路由对象中的变化
    '$route':'handlerRoute'
  },
  mounted() {
    this.handlerRoute()
    document.getElementById("body").className = "body-height-100"
    console.log("--->")
  },
  methods: {
    handlerRoute(to, from){
      console.log('Route changed from', from, 'to', to);
      this.pageTitle = this.$route.meta.title
    }
  },
}
</script>

<style lang="scss" scoped>
.main {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100vh;
  box-sizing: border-box;
  overflow: hidden;
  overflow-y:auto;

  scrollbar-color:var(--bg-primary-5) var(--bg-primary-3);
}
</style>